import React, { useCallback, useState } from 'react';
import OfferedClasses from './OfferedClasses';
import RequestClass from './RequestClass';
import MyClasses from './MyClasses';
import Orders from './Orders';
import CheckoutBanner from './CheckoutBanner';

const TABS = [
  { id: 'browse', label: 'Offered Classes' },
  { id: 'request', label: 'Request a Class' },
  { id: 'mine', label: 'My Classes' },
  { id: 'orders', label: 'Orders' },
];

export default function ClientTraining() {
  const [tab, setTab] = useState('browse');
  // A confirmed payment lands the buyer on their classes, where the new seats
  // are waiting to be assigned.
  const onPaid = useCallback(() => setTab('mine'), []);

  return (
    <div className="p-4 md:p-6 max-w-[1100px] mx-auto">
      <h1 className="text-lg font-semibold mb-3">Training</h1>
      <CheckoutBanner onPaid={onPaid} />
      <div className="flex gap-1 border-b border-gray-200 dark:border-gray-700 mb-5">
        {TABS.map((t) => (
          <button
            key={t.id}
            onClick={() => setTab(t.id)}
            className={`px-4 py-2 text-sm ${
              tab === t.id
                ? 'border-b-2 border-blue-500 font-semibold text-blue-600 dark:text-blue-400'
                : 'text-gray-500 hover:text-gray-700 dark:hover:text-gray-300'
            }`}
          >
            {t.label}
          </button>
        ))}
      </div>
      {tab === 'browse' && <OfferedClasses />}
      {tab === 'request' && <RequestClass onDone={() => setTab('mine')} />}
      {tab === 'mine' && <MyClasses />}
      {tab === 'orders' && <Orders />}
    </div>
  );
}
